var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilEditButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    focusable: "false",
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pencil-edit-button") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component-pencil-edit-button",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Atom-/Base-Icons-/-edit",
    fill: "#166471",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pencil-edit-button"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.32737048,2.50330675 L12.3787098,5.56956095 L4.65492739,13.3311692 L1.60531808,10.264915 L9.32737048,2.50330675 Z M14.6940861,1.76379654 L13.3333062,0.39635245 C12.8074118,-0.132117483 11.9534678,-0.132117483 11.4257867,0.39635245 L10.1222956,1.70622715 L13.1736349,4.77250985 L14.6940861,3.24461245 C15.1019713,2.83470126 15.1019713,2.17367923 14.6940861,1.76379654 Z M0.00849115735,14.5747821 C-0.0470393044,14.8259214 0.178599283,15.0509551 0.428543082,14.9898802 L3.82874869,14.1614224 L0.779139389,11.0951682 L0.00849115735,14.5747821 Z",
    id: "Shape-pencil-edit-button"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilEditButton);
export default __webpack_public_path__ + "static/media/pencil-edit-button.655e96bc8d0164e1018ee395d0fa4be8.svg";
export { ForwardRef as ReactComponent };